@for (i of count; track i) {
    <span class="path{{ i }}"></span>
}
